import React from 'react';

import { WanderingBoundaryPassageRowProviderState } from 'features/wandering-boundary-settings/providers/states/wandering-boundary-passage-row-provider-state';

const WanderingBoundaryPassageRowProviderContext = React.createContext<WanderingBoundaryPassageRowProviderState>({} as never);

export default WanderingBoundaryPassageRowProviderContext;
